import React from 'react';
import { List } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { timeFromNow } from '@nxsys/helpers/DateHelper';
import { reportExportTitle } from '@nxsys/utils/report-export-download';
import {
  StyledNotifyListItem,
  StyledNotifyMsgAvatar,
} from './NotificationItem.styled';

type NotificationItemProps = {
  item: {
    id: string;
    content: string;
    notificationType: string;
    isRead: boolean;
    createdAt: string;
    author?: string;
    assignedTo?: string;
  };
  // The signed-in user: a Report Builder entry is titled for its owner only.
  userId?: string;
  onClick?: () => void;
};

const NotificationItem: React.FC<NotificationItemProps> = ({
  item,
  userId,
  onClick,
}) => {
  const headline = reportExportTitle(item, userId);
  return (
    <StyledNotifyListItem
      className="item-hover"
      $isUnread={!item.isRead}
      onClick={onClick}
    >
      <List.Item.Meta
        avatar={
          <StyledNotifyMsgAvatar icon={<BellOutlined />} />
        }
        title={headline ?? item.content}
        description={
          headline ? (
            <>
              <div>{item.content}</div>
              <div>{item.createdAt ? timeFromNow(item.createdAt) : ''}</div>
            </>
          ) : item.createdAt ? (
            timeFromNow(item.createdAt)
          ) : (
            ''
          )
        }
      />
    </StyledNotifyListItem>
  );
};

export default NotificationItem;
